module.exports = __webpack_public_path__ + "img/bargain_title.c34ade45.png";